import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableFunction from '../../../../../components/table/TableFunction';
import { VIEW_TYPE } from '../../../../../enums/ViewType';
import { useTranslation } from 'react-i18next';
import { TABLES } from '../../../../../Apis/Tables';
import { SEARCH_MODEL } from '../../../../../components/table/Model/TableModel';
import { SimpleSearchWithId } from '../../../../../reduxToolkit/Search/SearchApi';
import { useNavigate } from 'react-router-dom';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const EquipmentAndMaterialCardApp = (props) => {
    const { selectForDelete, setSelectForDelete, isAllChecked, setIsAllChecked, view, modified, setModified, setBodyForExport, contractorId } = props;
    //Indicates development mode from global state
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    //Search results for equipment and materials
    const [searchResults, setSearchResults] = useState({ content: [], totalElements: 0 });
    //Reference used to compute and apply top offset in GRID view
    const elementRef = useRef(null);
    //element ID for the search input
    const [searchId] = useState('txt_eamca_equipment_and_material');
    //Search text input value
    const [searchElement, setSearchElement] = useState('');
    //Determines whether simple search mode is active
    const [simpleSearch, setSimpleSearch] = useState(false);
    //Module option key for search filters
    const option = `${TABLES.EQUIPMENT_MATERIAL}`;
    const { t } = useTranslation();
    //Global filters from SearchSlice
    const dispatch = useDispatch();
    const navigate = useNavigate();

    //Apply computed top offset when the view changes to GRID.
    useEffect(() => {
        if (elementRef.current) {
            const rect = elementRef.current.getBoundingClientRect();
            elementRef.current.style.setProperty('--top-value', `${rect.top}px`);
        }
    }, [searchResults?.content?.length]);

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = page => {
        const body = SEARCH_MODEL.setObject({
            page,
            size: rowsPerPage,
            model: option,
            userId: contractorId,
            key: searchElement
        });

        // Store the request body for export functionality
        setBodyForExport(body);
        // Dispatch the search action and handle the response
        dispatch(SimpleSearchWithId({ body })).then(
            ({
                payload: {
                    data: { data, success },
                },
            }) => {
                if (success === true) {
                    setSearchResults(data);
                }
            },
        );
    };

    //Table logic: pagination, selection, deletion, and checkbox management.
    const { page, rowsPerPage, handleCheckboxChange, handleDeleteAll, pagination } = TableFunction({
        data: searchResults,
        view: VIEW_TYPE.GRID.name,
        labelRowsPerPage: 'equipment_material_per_page',
        fixedPagination: false,
        hasContainer: true,
        selectedList: selectForDelete,
        setSelectedList: setSelectForDelete,
        setIsAllChecked,

        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    return {
        DEV,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        elementRef,
        searchResults,
        page,
        rowsPerPage,
        searchId,
        searchElement,
        option,
        setSimpleSearch,
        setSearchElement,
        t,
        setSearchResults,
        navigate,
    };
};

export default EquipmentAndMaterialCardApp;
